import { NotificationType } from "@/graphql/generated/types";

// The full set of notification types this client can render. Passed as
// `supportedTypes` to the notification query/subscriptions so genesis never
// sends an enum value spark was not generated against (genesis #113). Because
// this list is derived from the generated enum, it stays complete automatically
// as new types are added to the schema.
export const ALL_NOTIFICATION_TYPES: NotificationType[] = Object.values(NotificationType);
